/* eslint-disable global-require, max-len */

// Filenames of images must match slug of each newsletter item in `/wp-json/kauffman/v1/newsletter/config`.
// Image files should exist in `newsletters/components/images`.

const newsletterImage = {
  'amplify': require('../images/amplify.jpg'),
  'eship-ecosystems': require('../images/eship-ecosystems-2.jpg'),
  'insights-to-entrepreneurship': require('../images/insights-to-entrepreneurship-2.jpg'),
  'kauffman-indicators': require('../images/kauffman-indicators.jpg'),
  'kauffman-newsletter': require('../images/kauffman-newsletter-2.jpg'),
  'start-us-up-now-anbp': require('../images/start-us-up-now-anbp-2.jpg'),
};

export default newsletterImage;
